import React from 'react';
import { withLoading } from '@front-activerse/common-components';
import TrackerAddMeal from '../components/TrackerAddMeal';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import { normalizeFavMeal } from '../helpers/normalizers';
import { FavMealProps } from '../types';

const TrackerAddFavMealContainer: React.FC<FavMealProps> = (props) => {
  const normalizedProps = normalizeFavMeal(props);
  return (
    <TrackerAddMeal
      key={normalizedProps.mealData.id}
      {...normalizedProps}
      mode="backward-navigation"
    />
  );
};

export default withLoading(TrackerAddFavMealContainer, UniversalPlaceholder);
